module.exports = __webpack_public_path__ + "img/fondo.81287617.png";